<template>
	<div class="auctionDialog">
		<el-dialog title="竞拍配置" :visible.sync="flag" width="600px" @close="closeForm">
			<div class="dialog-content">
				<el-form :model="formData" :label-width="formLabelWidth">
					<div class="line">
						<div class="key">
							标的物名称：
						</div>
						<div class="value">
							{{info.name}}
						</div>
					</div>
					<div class="line">
						<div class="key">
							竞拍保证金：
						</div>
						<div class="value">
							{{info.deposit}}
						</div>
					</div>
					<div class="line">
						<div class="key">
							竞拍人信息：
						</div>
						<div class="value">

						</div>
					</div>
					<div class="address-line custom-scroll-bar">
						<!-- <el-form-item label="竞拍人信息">
							<el-input type="text" v-model="formData.username" autocomplete="off" placeholder="请输入竞拍人信息">
							</el-input>
						</el-form-item>
						<el-form-item label="竞拍人手机">
							<el-input type="number" v-model="formData.phone" autocomplete="off" placeholder="请输入竞拍人手机">
							</el-input>
						</el-form-item>
						<el-form-item label="竞拍人邮箱">
							<el-input type="email" v-model="formData.email" autocomplete="off" placeholder="请输入竞拍人邮箱">
							</el-input>
						</el-form-item>
						<el-form-item label="竞拍人地址">
							<el-input type="textarea" v-model="formData.address" autocomplete="off"
								placeholder="请输入竞拍人地址"></el-input>
						</el-form-item> -->
						<div class="address-empty" v-if="addressList.length==0">
							当前无拍卖人信息，请 <el-button type="primary" size="mini" @click="goAddress()">设置拍卖人信息</el-button>
						</div>
						<div :class="'address-item '+(addressIndex == index ? 'address-selected' : '')"
							v-for="(item,index) in addressList" :key="index" @click="useThisAddress(index)">
							<div>
								{{item.receiverName}} {{item.receiverPhone}} {{item.email}}<br>
								{{item.addressDetail}}
							</div>
							<div>
								<i class="el-icon-edit" @click="editThisAddress(item.id)"></i>
							</div>
						</div>
					</div>
					<div class="line">
						<div class="key">
							自动竞拍设置：
						</div>
						<div class="value">

						</div>
					</div>
					<div class="form-line">
						<el-form-item label="最高出价">
							<!-- 固定步长 -->
							<!-- <div class="setTop">
								起拍价：<span>{{info.start}}</span> +
								<el-input type="number" v-model="formData.step" disabled autocomplete="off" @input="stepChange">
									<el-button slot="prepend" icon="el-icon-minus" :disabled="formData.step == 0"
										@click="minusBid"></el-button>
									<el-button slot="append" icon="el-icon-plus" @click="addBid"></el-button>
								</el-input>
								= 最高出价：{{formData.top}}
							</div> -->
							<!-- 非固定步长 -->
							<!-- <div class="setTop">
								起拍价：<span>{{info.start}}</span> +
								<el-input type="number" v-model="formData.step" autocomplete="off" @input="stepChange">
									<el-button slot="prepend" icon="el-icon-minus" :disabled="formData.step == 0"
										@click="minusBid"></el-button>
									<el-button slot="append" icon="el-icon-plus" @click="addBid"></el-button>
								</el-input>
								= 最高出价：{{formData.top}}
							</div> -->
							<el-input type="number" v-model="formData.top" auto-complete="off"
								:min="info.current?info.current:info.start"
								:placeholder="'当前最高出价不应低于'+(info.current?info.current:info.start)"></el-input>
						</el-form-item>
						<!-- <el-form-item label="出价策略">
							<el-col :span="11">
								<el-input type="number" width="150px" v-model="formData.min" placeholder="最低秒数"
									autocomplete="off"></el-input>
							</el-col>
							<el-col :span="2">
								-
							</el-col>
							<el-col :span="11">
								<el-input type="number" width="150px" v-model="formData.max" placeholder="最高秒数"
									autocomplete="off"></el-input>
							</el-col>
						</el-form-item> -->
						<el-form-item label="当前最高出价" v-if="formData.setTop>0">
							<span>¥{{formData.setTop}}</span>
						</el-form-item>
					</div>
					<div class="hint">
						<div class="icon">
							<i class="el-icon-warning"></i>
						</div>
						<div class="content">
							注：当您提交最高出价后，我们将自动为您出价，直到您获得最高出价或达到最高出价。<br>
							如果达到您的最高出价的90%或有人拍出更高的出价，我们将通过电子邮件通知您。<br>
							其他出价者无法看到您的最高出价有多高。
						</div>
					</div>
					<div class="line">
						<div class="key">
							提醒设置：
						</div>
						<div class="value">

						</div>
					</div>
					<div class="form-line">
						<el-form-item label="开拍提醒">
							<el-switch :width="50" v-model="formData.remind" active-color="#f79803"></el-switch>
							<div class="switch-hint">
								开拍前15分钟邮件提醒
							</div>
						</el-form-item>
						<el-form-item label="加价提醒">
							<el-switch :width="50" v-model="formData.remind" active-color="#f79803"></el-switch>
							<div class="switch-hint">
								有人超过己方出价时，邮件提醒，当设置自动竞拍后仅在需要人为干预时进行提醒
							</div>
						</el-form-item>
						<el-form-item label="截拍提醒">
							<el-switch :width="50" v-model="formData.remind" active-color="#f79803"></el-switch>
							<div class="switch-hint">
								在截拍前15分钟邮件提醒
							</div>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button round @click="closeForm">关闭</el-button>
					<el-button round type="primary" @click="submitForm">{{!info.isJoin?'立即参与':'确认'}}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'auctionDialog',
		props: ['formData', 'info'],
		data() {
			return {
				formLabelWidth: '120px',
				flag: false,
				addressList: [],
				addressIndex: 0
			};
		},
		methods: {
			// stepChange(){
			// 	this.$props.formData.top = this.$props.info.current + parseFloat(this.$props.formData.step)
			// },
			// minusBid() {
			// 	if (this.$props.formData.bid > (this.$props.info.current + this.$props.info.add)) {
			// 		this.$props.formData.bid = this.$props.formData.bid - this.$props.info.add
			// 	}
			// },
			// addBid() {
			// 	this.$props.formData.step = this.$props.formData.step+this.$props.info.add
			// 	this.$props.formData.top = this.$props.info.current+this.$props.formData.step
			// },
			goAddress(){
				this.$router.push({
					path:"/setting"
				})
			},
			submitForm() {
				if (!this.$props.info.isJoin) {
					this.$api.frontJoinAuction({
						memberId: this.$store.state.userinfo.userId,
						lotId: this.$props.info.id,
						lotName: this.$props.info.name,
						bondPrice: this.$props.info.deposit
					}, res => {
						if (res.code == 200) {
							this.$router.push({
								path: '/payment',
								query: {
									order: res.data,
									type: 1
								}
							})
						}
					})
				}
				if (this.$props.formData.top >= (this.$props.info.current ? this.$props.info.current : this.$props.info
						.start)) {
					this.$api.frontMaxPrice({
						maxPrice: this.$props.formData.top,
						memberId: this.$store.state.userinfo.userId,
						lotId: this.$props.info.id,
					}, res => {
						if (res.code == 200) {
							this.$message({
								message: '设置自动出价成功',
								type: 'success'
							})
						}
					})
				} else {
					this.$message({
						type: 'error',
						message: '设置最高出价不可低于当前价格。',
						duration: 1500
					})
				}
				if (this.$props.formData.remind) {
					this.$api.frontOpenRemind({
						lotId: this.$props.info.id,
						addressId: this.addressList[this.addressIndex]['id'],
						memberId: this.$store.state.userinfo.userId,
					}, res => {
						if (res.code == 200) {
							this.$message({
								message: '设置提醒成功',
								type: 'success'
							})
						}
					})
				}
				this.closeForm()
			},
			closeForm() {
				this.$emit('closeAuction')
			},
			fetchAddressList() {
				this.$api.frontAddressList({
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.addressList = res.data.list
					}
				})
			},
			useThisAddress(index) {
				this.addressIndex = index
			},
			editThisAddress(id) {
				this.$router.push({
					path: '/address',
					query: {
						id: id
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.flag = true
			this.fetchAddressList()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.dialog-content {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	.line {
		width: 100%;
		display: flex;
		margin-bottom: @vue-spacing-col-base;

		.key {
			width: 120px;
			height: 30px;
			border-left: 4px solid @vue-border-color-red;
			box-sizing: border-box;
			line-height: 30px;
			padding-left: @vue-spacing-row-sm;
		}

		.value {
			width: calc(100% - 120px);
			line-height: 30px;
			display: flex;
			align-items: center;
		}
	}

	.address-line {
		width: 100%;
		max-height: 210px;
		overflow: auto;
		margin: @vue-spacing-col-base 0px;
	}

	.address-empty {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		.el-button{
			margin-left: @vue-spacing-row-sm
		}
	}

	.address-item {
		width: 100%;
		box-sizing: border-box;
		padding: @vue-spacing-col-sm @vue-spacing-row-base;
		cursor: pointer;
		display: flex;
		line-height: 25px;

		div {
			margin-right: @vue-spacing-row-base;
			display: flex;
			align-items: center;

			i {
				font-size: @vue-font-size-sm + 2;
			}
		}
	}

	.address-selected {
		border: 1px solid #f79803;
		background: #fffde0;
		color: #f79803;
	}

	.hint {
		width: 100%;
		border: 1px solid #f79803;
		box-sizing: border-box;
		background: #fffde0;
		color: #f79803;
		padding: @vue-spacing-col-sm @vue-spacing-row-base;
		margin-bottom: @vue-spacing-col-base;
		display: flex;
		line-height: 30px;

		.icon {
			padding-right: @vue-spacing-row-sm;
			box-sizing: border-box;
		}
	}

	.switch-hint {
		color: #f79803;
		line-height: 30px;
	}

	.dialog-footer {
		display: flex;
		justify-content: flex-end;
	}

	.setTop {
		width: 100%;
		height: 100%;
		display: flex;

		.el-input {
			width: 60px;
			margin: 0 8px;
		}
	}
</style>
